const BOOKED_GUIDANCE = 'Open the appointment modal to see room availability.';

/**
 * Classify a failed drag-reschedule. `rawMessage` is only matched, never shown;
 * `userFacingMessage` is the environment-safe text (`getUserFacingErrorMessage`): the full text
 * outside production, and in production only when the bot text was allowlisted as a `UserFacingError`.
 * Returns `message: ''` when the error is not a booked-resource conflict.
 */
export function classifyRescheduleError({
  rawMessage,
  userFacingMessage,
  hasScheduledResources,
}: {
  rawMessage: string;
  userFacingMessage: string;
  hasScheduledResources: boolean;
}): { isBooked: boolean; message: string } {
  const isBooked = hasScheduledResources && /is booked/i.test(rawMessage);
  if (!isBooked) return { isBooked, message: '' };
  const lead = userFacingMessage ? `${userFacingMessage}.` : 'That time is unavailable.';
  return { isBooked, message: `${lead} ${BOOKED_GUIDANCE}` };
}
